/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type AuthDialog_user$ref = any;
type ShopWithCeoDialog_user$ref = any;
export type SearchBarNav_user$ref = any;
export type SearchBarNav_user = {
    readonly userId: string | null;
    readonly shoppingWithCeoUser: ({
        readonly id: string;
        readonly publicId: string | null;
        readonly userId: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly profile: ({
            readonly id: string;
            readonly image: string | null;
        }) | null;
    }) | null;
    readonly permissions: ({
        readonly id: string;
        readonly oneCommerce: ({
            readonly id: string;
            readonly ceo: ({
                readonly access: boolean | null;
            }) | null;
        }) | null;
    }) | null;
    readonly conciergeUser: ({
        readonly userId: string | null;
    }) | null;
    readonly conciergeCustomerAccountId: string | null;
    readonly cart: ({
        readonly id: string;
        readonly eventId: string | null;
        readonly event: ({
            readonly id: string;
            readonly trinityPartyType: string | null;
        }) | null;
    }) | null;
    readonly autoCompleteData: ({
        readonly edges: ReadonlyArray<({
            readonly node: ({
                readonly id: string;
                readonly isCEO: boolean | null;
                readonly ceoId: string | null;
                readonly image: string | null;
                readonly isEvent: boolean | null;
                readonly isProduct: boolean | null;
                readonly routePath: string | null;
                readonly primaryLabel: string | null;
                readonly secondaryLabel: string | null;
                readonly productCategory: string | null;
            }) | null;
        }) | null> | null;
    }) | null;
    readonly " $fragmentRefs": AuthDialog_user$ref & ShopWithCeoDialog_user$ref;
    readonly " $refType": SearchBarNav_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "image",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "SearchBarNav_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "ceoId",
                "type": "String",
                "defaultValue": "none"
            },
            {
                "kind": "LocalArgument",
                "name": "inputValue",
                "type": "String",
                "defaultValue": null
            },
            {
                "kind": "LocalArgument",
                "name": "searchCEOS",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "searchEvents",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "searchProducts",
                "type": "Boolean",
                "defaultValue": false
            }
        ],
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "AuthDialog_user",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ShopWithCeoDialog_user",
                "args": null
            },
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "shoppingWithCeoUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "publicId",
                        "args": null,
                        "storageKey": null
                    },
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "profile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Profile",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            (v2 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "permissions",
                "storageKey": null,
                "args": null,
                "concreteType": "PermissionsType",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "oneCommerce",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OneCommerceType",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ceo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AccessType",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "access",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "conciergeUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "conciergeCustomerAccountId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "cart",
                "storageKey": null,
                "args": null,
                "concreteType": "Cart",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "trinityPartyType",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "autoCompleteData",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "ceoId",
                        "variableName": "ceoId",
                        "type": "String"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 10,
                        "type": "Int"
                    },
                    {
                        "kind": "Variable",
                        "name": "inputValue",
                        "variableName": "inputValue",
                        "type": "String"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchCEOS",
                        "variableName": "searchCEOS",
                        "type": "Boolean"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchEvents",
                        "variableName": "searchEvents",
                        "type": "Boolean"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchProducts",
                        "variableName": "searchProducts",
                        "type": "Boolean"
                    }
                ],
                "concreteType": "AutoCompleteEntryConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AutoCompleteEntryEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AutoCompleteDataEntry",
                                "plural": false,
                                "selections": [
                                    (v1 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isCEO",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "ceoId",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v2 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isEvent",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isProduct",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "routePath",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "primaryLabel",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "secondaryLabel",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "productCategory",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '7f21bdff8a4dab439bb935e1e69c71bf';
export default node;
